module.exports = __webpack_public_path__ + "static/media/nodata.c5cdbe14.png";